import { render } from "./SignInScreen.vue?vue&type=template&id=51a2fd18"
import script from "./SignInScreen.vue?vue&type=script&lang=js"
export * from "./SignInScreen.vue?vue&type=script&lang=js"

import "./SignInScreen.vue?vue&type=style&index=0&id=51a2fd18&lang=css"
script.render = render

export default script